import _omit from 'lodash/omit';
import _values from 'lodash/values';
import sizes from "./sizes";
export var spacing = {
  AUTO: 'auto',
  FULL: 'full',
  LARGE: sizes.LARGE,
  MEDIUM: sizes.MEDIUM,
  SMALL: sizes.SMALL,
  VIEWPORT: 'viewport',
  ZERO: '0'
};
spacing.LAYOUT = _values(_omit(spacing, ['VIEWPORT', 'FULL']));
spacing.DIMENSION = [spacing.FULL, spacing.AUTO, spacing.VIEWPORT];
//# sourceMappingURL=spacing.js.map